import { Close } from "@mui/icons-material";
import { IconButton, Modal, Paper } from "@mui/material";
import React from "react";
import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  getInterests,
  updateProfile,
} from "../../../redux/actions/profileActions";
import { CLOSE_EDIT_INTERESTS } from "../../../redux/types";

const EditInterest = () => {
  const { openInterests: open } = useSelector((state) => state.ModalsControl);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    let values = [];

    for (let value of formData.values()) {
      values.push(value);
    }
    console.log(values);

    dispatch(updateProfile({ interests: values }));
    dispatch({ type: CLOSE_EDIT_INTERESTS });
    e.target.reset();
  };
  const dispatch = useDispatch();

  const { interests } = useSelector((state) => state.InterestsList);
  const { profile } = useSelector((state) => state.ProfileDetails);

  useEffect(() => {
    dispatch(getInterests());
  }, []);
  return (
    <Modal
      className="grid place-items-center"
      open={open}
      onClose={() => dispatch({ type: CLOSE_EDIT_INTERESTS })}>
      <Paper elevation={8} className="!bg-slate-100  p-2 w-[90%] relative">
        <IconButton
          className="absolute top-0 left-4"
          onClick={() => dispatch({ type: CLOSE_EDIT_INTERESTS })}>
          <Close />
        </IconButton>
        <form onSubmit={handleSubmit}>
          <div className="flex flex-wrap p-4">
            {interests.map((x) => (
              <div className="m-2" key={x._id}>
                <input
                  name={x.name}
                  value={x._id}
                  defaultChecked={profile.interests.some(
                    (y) => y._id === x._id
                  )}
                  type="checkbox"
                  id={x._id}
                  className="peer sr-only w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  htmlFor={x._id}
                  className="flex cursor-pointer px-3 rounded-2xl bg-gray-200 justify-center items-center h-10 w-full peer-checked:bg-blue-500 peer-checked:text-white text-[17px] text-sm font-medium text-gray-900 dark:text-gray-300">
                  {x.name}
                </label>
              </div>
            ))}

            {/* 
             <div >
             <input id="default-radio-1" type="checkbox" value="" name="default-radio" class="peer opacity-0 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
            <label for="default-radio-1" class="flex cursor-pointer  bg-gray-200 justify-center items-center h-10 w-full peer-checked:bg-rose-500 peer-checked:text-white text-[17px] text-sm font-medium text-gray-900 dark:text-gray-300">India</label>
             </div> */}
          </div>

          <button className="w-full px-2 py-2 rounded bg-rose-500 text-white">
            save
          </button>
        </form>
      </Paper>
    </Modal>
  );
};

export default EditInterest;
